import domReady from '@wordpress/dom-ready';

domReady(() => {
  const findstr = window.findstr || {};

  setAdsPos();
  findstr.hooks.addAction(
    'afterSearchResults',
    'mainSearch',
    (results, group) => {
      if ('main-search' !== group) {
        return;
      }
      setAdsPos();
      const container = document.querySelector('.search-results__main-wrapper');
      if (container) {
        if (results.totalHits === 0) {
          container.classList.add('flex-column');
        } else {
          container.classList.remove('flex-column');
        }
      }
    }
  );

  window.addEventListener('resize', () => {
    setAdsPos();
  });

  function setAdsPos() {
    const ads = document.querySelector('.findstr-search-result-item--ads');

    if (!ads) {
      return;
    }

    const items = document.querySelectorAll('.findstr-search-result-item');

    let height = 0;

    if (ads.classList.contains('no-results')) {
      ads.classList.remove('no-results');
    }

    if (items.length === 0) {
      ads.classList.add('no-results');
    } else if (items.length > 4) {
      for (let i = 0; i < 4; i++) {
        const item = items[i];
        height += item.offsetHeight + 20;
        if (i === 3) {
          item.style.marginBottom = ads.offsetHeight + 40 + 'px';
        }
      }
    } else {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        height += item.offsetHeight + 20;
        if (i === items.length - 1) {
          item.style.marginBottom = ads.offsetHeight + 40 + 'px';
        }
      }
    }

    ads.style.top = height + 'px';
  }
});
